import { getRequest } from '..';

export function get() {
  return getRequest('/sporttype');
}